module.exports = __webpack_public_path__ + "img/Flatbed (2).ec1d94f6.jpg";